import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class ApiAttributesMappingService {

  attrsSwitchSubject = new Subject<any>();
  attrListDataSubject = new Subject<any>();
  attrDataSubject = new Subject<any>();

  constructor(
    private apiBasic: ApiBasicService
  ) { }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'attributes_mapping');
  }

  /**
  * 
  * @param id string
  * @returns Observable<Res>
  */
  edit(id: string): Observable<Res> {

    return this.apiBasic.edit('attributes_mapping', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('attributes_mapping', params);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('attributes_mapping', params);
  }

  /**
   * 
   * @param params 
   * @returns 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('attributes_mapping', params);
  }

  /**
  * 
  * @param data 
  */
  switchTab(data: string): void {

    this.attrsSwitchSubject.next(data);
  }

  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
   listenerSwitchTab(): Observable<any> {

    return this.attrsSwitchSubject.asObservable();
  }

  /**
  * 
  * @param data 
  */
  setAttrMappingListsData(data: any): void {

    this.attrListDataSubject.next(data);
  }

  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
   listenerAttrMappingListData(): Observable<any> {

    return this.attrListDataSubject.asObservable();
  }

  /**
   * 
   * @param data 
   */
  setAttrMappingData(data: any): void {

    this.attrDataSubject.next(data);
  }

  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
  listenerAttrMappingData(): Observable<any> {

    return this.attrDataSubject.asObservable();
  }
}
